import { Box, Button, Icon, Icons, Text, config, toRem } from 'folds';
import { Page, PageHero, PageHeroSection } from '$components/page';
import { versionLabel } from '$utils/platform';
import LogoSVG from '$public/res/svg/logo.svg';

export function WelcomePage() {
  return (
    <Page>
      <Box
        grow="Yes"
        style={{ padding: config.space.S400, paddingBottom: config.space.S700 }}
        alignItems="Center"
        justifyContent="Center"
      >
        <PageHeroSection>
          <PageHero
            icon={<img width="125" height="125" src={LogoSVG} alt="Mable Logo" />}
            title="Welcome to Mable"
            subTitle={
              <span>
                A M(ostly st)able Matrix client. Based on the hard work of the Cinny & Sable development teams{' '}
                <a
                  href="https://github.com/Merconix/Mable"
                  target="_blank"
                  rel="noreferrer noopener"
                >
                  {versionLabel()}
                </a>
              </span>
            }
          >
            <Box justifyContent="Center">
              <Box grow="Yes" style={{ maxWidth: toRem(300) }} direction="Column" gap="300">
                <Button
                  as="a"
                  href="https://github.com/Merconix/Mable"
                  target="_blank"
                  rel="noreferrer noopener"
                  before={<Icon size="200" src={Icons.Code} />}
                >
                  <Text as="span" size="B400" truncate>
                    Source Code
                  </Text>
                </Button>
                <Button
                  as="a"
                  href="https://github.com/Merconix/Mable-Electron/releases/latest"
                  target="_blank"
                  rel="noreferrer noopener"
                  fill="Soft"
                  before={<Icon size="200" src={Icons.Code} />}
                >
                  <Text as="span" size="B400" truncate>
                    Desktop App
                  </Text>
                </Button>
              </Box>
            </Box>
            <Box direction="Column" gap="200" alignItems="Center">
              <Button
                as="a"
                href="https://opencollective.com/sable"
                target="_blank"
                rel="noreferrer noopener"
                before={<Icon size="200" src={Icons.Heart} />}
              >
                <Text as="span" size="B400" truncate>
                  Sable
                </Text>
              </Button>
            </Box>
          </PageHero>
        </PageHeroSection>
      </Box>
    </Page>
  );
}
